import React, { useState, useEffect, useRef, useMemo, forwardRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service.js';
import '../../pages/OtherDocuments/OtherDocument.css';
import '../../pages/Document/Document.scss';
import backIcon from '../../assests/images/left-arrow.png';
import { GridToolbarContainer } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js';
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useSignalR } from '../../Contexts/signalR.js';
import 'primereact/resources/themes/saga-blue/theme.css';    // Optional: PrimeReact theme
import 'primereact/resources/primereact.min.css';           // PrimeReact CSS
import 'primeicons/primeicons.css';
import { useBack } from "use-back";
import SaveIcon from '@mui/icons-material/Save'; // Save icon
import ClearIcon from '@mui/icons-material/Clear';
import PuffLoader from "react-spinners/PuffLoader";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import MergeIcon from '@mui/icons-material/Merge';
import MergeAccountCards from '../../Components/AccountCardsTable/MergeAccountCards/MergeAccountCards.js';
import BatchMergeAccountCards from '../../Components/AccountCardsTable/MergeAccountCards/BatchMergeAccountCards.js';
import MergeSelectedCardsDialog from '../../Components/AccountCardsTable/MergeSelectedCardsDialog.jsx';
import ConflictResolutionDialog from '../../Components/AccountCardsTable/ConflictResolutionDialog/ConflictResolutionDialog.jsx';
import PalCodePrefixesDialog from '../../Components/AccountCardsTable/PalCodePrefixesDialog.jsx';
import SystemAccountSettingsDialog from '../../Components/AccountCardsTable/SystemAccountSettingsDialog.jsx';
import ReorderByPrefixDialog from '../../Components/AccountCardsTable/ReorderByPrefixDialog.jsx';
import PreviewUploadDialog from '../../Components/AccountCardsTable/PreviewUploadDialog/PreviewUploadDialog.jsx';
import AccountCardService from '../../Services/accountcard.service.js';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import editIcon from '../../assests/images/Icons/editIcon.svg';
import deleteIcon from '../../assests/images/Icons/deleteIcon.svg';
import ledger from '../../assests/images/Icons/ledger.svg';
import saveIcon from '../../assests/images/Icons/saveIcon.svg';
import cancelIcon from '../../assests/images/Icons/cancelIcon.svg';
import { Edit as EditIcon, Delete as DeleteIcon, Search as SearchIcon, Download as DownloadIconMui, Settings, LockOpen } from '@mui/icons-material';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import { useGridApiRef } from '@mui/x-data-grid';
import { PermissionsContext } from '../../Contexts/Permissions';
// MUI DataGrid imports
import {
    DataGrid,
    GridToolbar,
    GridRowModes,
    GridActionsCellItem,
} from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import {
    TextField,
    Autocomplete,
    InputAdornment,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Tooltip,
    CircularProgress,
    Box,
    Popper,
    Select,
    MenuItem,
    FormControl,
    FormControlLabel,
    InputLabel,
    Switch,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS, arSA, he } from 'date-fns/locale'; // Import desired locales
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { textAlign } from '@mui/system';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import styles from './AccountCardsTable.module.scss';
import EditAccountCardModal from '../../Components/AccountCardsTable/SubComponents/EditAccountCardModal.js';
import AccountCardFile from "../../assests/templates/Xtram_accountCards_Template.xlsx";
import { handleDownloadTemplate } from '../../Utils/handleDownloadTemplate';
import AddAccountCardModal from '../../Components/Widgets/AddAccountCardModal/AddAccountCardModal.jsx';
import BulkEditDialog from '../../Components/AccountCardsTable/SubComponents/BulkEditDialog.jsx';
import CashFlowForecastService from '../../Services/cashFlowForecast.service.js';
import DeleteZeroTransactionCardsDialog from '../../Components/AccountCardsTable/DeleteZeroTransactionCardsDialog.jsx';
import Constants from '../../assests/Constants/constants.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import NoDocumentsPdf from '../../assests/pdf/NoDocument.pdf';
import CloseIcon from '@mui/icons-material/Close';
import {
    fetchAccountCardsTablePageData,
    setAccountCardsData as setAccountCardsDataAction,
    resetAccountCardsTablePage,
} from '../../store/reducers/accountCardsTablePageSlice';

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Table view persistence and presets (priority = always shown)
const STORAGE_KEY_ACCOUNT_CARDS_VIEW = 'accountCardsTable_view';
const STORAGE_KEY_ACCOUNT_CARDS_COLUMN_WIDTHS = 'accountCardsTable_columnWidths';
const TABLE_VIEWS = ['compact', 'standard', 'full'];
const TABLE_VIEW_MENU_PROPS = {
    PaperProps: {
        sx: {
            mt: 0.5,
            borderRadius: '8px',
            border: '1px solid #e5e7f6',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden',
            minWidth: 'var(--xtram-menu-width)',
            '& .MuiList-root': { p: 0 },
            '& .MuiMenuItem-root': {
                minHeight: 'var(--xtram-menu-item-height)',
                px: 'var(--xtram-menu-item-pad-x)',
                py: 'var(--xtram-menu-item-pad-y)',
                fontSize: 'var(--xtram-text-sm)',
                fontWeight: 400,
                lineHeight: 1.35,
                color: '#696665',
                transition: 'background-color 0.2s ease, color 0.2s ease',
                '&:not(:last-of-type)': { borderBottom: '1px solid #f0f0f0' },
                '&:hover': { backgroundColor: '#304fff', color: '#ffffff' },
                '&.Mui-selected': {
                    backgroundColor: 'rgba(48, 79, 255, 0.1)',
                    color: '#304fff',
                    '&:hover': { backgroundColor: '#304fff', color: '#ffffff' },
                },
            },
        },
    },
};
const VIEW_INCLUDES_TIER = {
    compact: ['priority', 'compact'],
    standard: ['priority', 'compact', 'standard'],
    full: ['priority', 'compact', 'standard', 'full'],
};

// Styled DataGrid component
const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    width: '100%',
    '& .MuiAutocomplete-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"

    },
    '& *': {
        boxSizing: 'border-box !important',

    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#E3E7FE',
        minHeight: '42px !important',
        maxHeight: '42px !important',
        lineHeight: '42px',
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#E3E7FE',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
        minHeight: '42px !important',
        maxHeight: '42px !important',
        height: '42px !important',
        boxSizing: 'border-box',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#1222b3',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: 'normal',
    },
    '& .MuiDataGrid-sortIcon': {
        opacity: '0.8 !important',
        color: '#1222b3',
    },
    '& .MuiDataGrid-menuIconButton': {
        color: '#1222b3',
    },
    '& .MuiDataGrid-main, & .MuiDataGrid-overlayWrapper': {
        backgroundColor: '#ffffff',
    },
    '& .MuiDataGrid-virtualScroller': {
        backgroundColor: '#ffffff',
        overflowX: 'auto',
        scrollbarWidth: 'var(--register-scrollbar-width, var(--xtram-scrollbar-width, thin))',
        scrollbarColor: '#d8daf2 transparent',
        borderRadius: 'inherit',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
        background: '#d8daf2',
        borderRadius: 'var(--xtram-radius-pill, 999px)',
    },
    '& .MuiDataGrid-scrollbar': {
        scrollbarWidth: 'var(--register-scrollbar-width, var(--xtram-scrollbar-width, thin))',
        scrollbarColor: '#d8daf2 transparent',
        borderRadius: 'inherit',
    },
    '& .MuiDataGrid-scrollbar::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
    },
    '& .MuiDataGrid-scrollbar::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '& .MuiDataGrid-scrollbar::-webkit-scrollbar-thumb': {
        background: '#d8daf2',
        borderRadius: 'var(--xtram-radius-pill, 999px)',
    },
    '& .MuiDataGrid-scrollbar.MuiDataGrid-scrollbar--horizontal': {
        display: 'block',
        height: '6px',
    },
    '& .MuiDataGrid-cell': {
        borderTop: '1px solid rgba(191, 191, 193, 0.56)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        lineHeight: 1.3,
        overflow: 'hidden',
    },
    '& .MuiDataGrid-row': {
        maxHeight: 'none !important',
    },
    '& .MuiDataGrid-cellContent, & .MuiDataGrid-cell span': {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        maxWidth: '100%',
        lineHeight: 1.3,
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(227, 230, 255, 0.3)',
    },
    '& .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '& .disableUser': {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    // New styles for edit mode
    '& .MuiDataGrid-cell--editing': {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell': {
        borderRight: 'none',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell:not(:last-child)': {
        borderRight: '8px solid transparent',
    },
    '& .MuiDataGrid-cell--editing': {
        padding: 0,
        backgroundColor: 'inherit',
    },
    '& .document-cell': {
        padding: '8px 16px',
        gap: '8px',
    },
}));

const validateEmail = (email) => {
    // Simple email validation
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};

const validateNumber = (number) => {
    const re = /^[0-9\b]+$/;
    return re.test(number);
};

const AccountCardsTable = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();
    const [localLoading, setLocalLoading] = useState(false);
    const [isClientDataFetched, setIsClientDataFetched] = useState(false);

    const [focused, setFocused] = useState(false);
    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();

    const dispatch = useDispatch();
    const accountCardsTablePage = useSelector((state) => state.accountCardsTablePageSlice || {});
    const accountCardsData = accountCardsTablePage.accountCardsData || [];
    const palCodesOptions = (accountCardsTablePage.palCodesOptions && accountCardsTablePage.palCodesOptions.length > 0)
        ? accountCardsTablePage.palCodesOptions
        : [{ key: '', label: '', value: '' }];
    const sortCodesOptions = (accountCardsTablePage.sortCodesOptions && accountCardsTablePage.sortCodesOptions.length > 0)
        ? accountCardsTablePage.sortCodesOptions
        : [{ key: '', label: '', value: '' }];
    const reservedAccountCardIds = accountCardsTablePage.reservedAccountCardIds || [];
    const palCodePrefixes = accountCardsTablePage.palCodePrefixes || [];
    const pageLoading = accountCardsTablePage.loading || false;
    const isInitialAccountCardsLoad = (accountCardsTablePage.accountCardsData?.length ?? 0) === 0;

    const setAccountCardsData = (next) => {
        const current = accountCardsTablePage.accountCardsData || [];
        const value = typeof next === 'function' ? next(current) : next;
        dispatch(setAccountCardsDataAction(value));
    };

    const loading = localLoading || pageLoading;

    const fetchInFlightRef = useRef(false);
    const initialLoadDoneRef = useRef(false);

    const [rows, setRows] = useState([]); // Initialize with data prop


    const fileInputRef1 = useRef(null); // Reference to the first hidden file input

    const [selectedRows, setSelectedRows] = useState([]);
    const [rowModesModel, setRowModesModel] = useState({});
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [isMergeModalVisible, setMergeModalVisible] = useState(false);
    const [isBatchMergeModalVisible, setBatchMergeModalVisible] = useState(false);
    const [mergeSelectedModalVisible, setMergeSelectedModalVisible] = useState(false);
    const [mergeSelectedProcessing, setMergeSelectedProcessing] = useState(false);
    const [openEditSelected, setOpenEditSelected] = useState(false);
    const [isConflictDialogVisible, setIsConflictDialogVisible] = useState(false);
    const [uploadConflicts, setUploadConflicts] = useState([]);
    const [isPreviewDialogVisible, setIsPreviewDialogVisible] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [selectedPalCodeForSelectAll, setSelectedPalCodeForSelectAll] = useState('');
    const [selectedSortCodeForSelectAll, setSelectedSortCodeForSelectAll] = useState('');
    const [selectedAutoProcessedForSelectAll, setSelectedAutoProcessedForSelectAll] = useState(false);
    const [selectedSourceDeductionForSelectAll, setSelectedSourceDeductionForSelectAll] = useState('');
    const [selectedDeductionTypeForSelectAll, setSelectedDeductionTypeForSelectAll] = useState('');
    const [selectedTaxAssessorForSelectAll, setSelectedTaxAssessorForSelectAll] = useState('');
    const [selectedDeductionRateForSelectAll, setSelectedDeductionRateForSelectAll] = useState('');
    const [selectedDeductionValidityForSelectAll, setSelectedDeductionValidityForSelectAll] = useState('');
    const [selectedPaymentTermsTypeForSelectAll, setSelectedPaymentTermsTypeForSelectAll] = useState('');
    const [selectedPaymentTermsDaysForSelectAll, setSelectedPaymentTermsDaysForSelectAll] = useState('');
    const [selectedIncludeInCashFlowForSelectAll, setSelectedIncludeInCashFlowForSelectAll] = useState(false);
    const [selectedCashFlowCodeForSelectAll, setSelectedCashFlowCodeForSelectAll] = useState('');
    const [selectedCashFlowAverageAmountForSelectAll, setSelectedCashFlowAverageAmountForSelectAll] =
        useState('');
    const [selectedPalCode, setSelectedPalCode] = useState(null);
    const [hideNonEditableCards, setHideNonEditableCards] = useState(false);
    const [bulkDeleteModalVisible, setBulkDeleteModalVisible] = useState(false);
    const [bulkDeleteCardIds, setBulkDeleteCardIds] = useState([]);
    const [bulkDeleteProcessing, setBulkDeleteProcessing] = useState(false);
    const [zeroTxDeleteModalOpen, setZeroTxDeleteModalOpen] = useState(false);
    const [zeroTxCards, setZeroTxCards] = useState([]);
    const [zeroTxLoading, setZeroTxLoading] = useState(false);
    const [prefixDialogOpen, setPrefixDialogOpen] = useState(false);
    const [systemSettingsDialogOpen, setSystemSettingsDialogOpen] = useState(false);
    const [reorderDialogOpen, setReorderDialogOpen] = useState(false);
    const [makeEditableConfirmOpen, setMakeEditableConfirmOpen] = useState(false);
    const [makeEditableConfirmPayload, setMakeEditableConfirmPayload] = useState(null);
    const [sortByPrefixOrder, setSortByPrefixOrder] = useState(false);
    const [tableView, setTableView] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY_ACCOUNT_CARDS_VIEW);
            return TABLE_VIEWS.includes(saved) ? saved : 'standard';
        } catch {
            return 'standard';
        }
    });
    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY_ACCOUNT_CARDS_VIEW, tableView);
        } catch (_) {}
    }, [tableView]);
    const [columnWidths, setColumnWidths] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY_ACCOUNT_CARDS_COLUMN_WIDTHS);
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            return typeof parsed === 'object' && parsed !== null ? parsed : {};
        } catch {
            return {};
        }
    });
    const dir = i18n.dir();
    const direction = dir;
    const apiRef = useGridApiRef();
    const [selectedRow, setSelectedRow] = useState(null);
    const [oldCard, setOldCard] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNew, setIsNew] = useState(false); // To differentiate between edit and add
    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const { goBack } = useContext(NavHistoryContext);
    const { userTypeContext, permissionsState } = useContext(PermissionsContext);
    // const { hasBack, handleBack } = useBack();
    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    //   const prevClientRef = useRef();
    //   const { setMenuProps } = useHamburgerMenu();
    //   // setMenuProps({ client, showIcon: true });›
    //   useEffect(() => {
    //       if (!client || prevClientRef.current?.clientId === client.clientId) return;
    //       prevClientRef.current = client;
    //       setMenuProps({ client });
    //     }, [client, setMenuProps]);  
    const handleCloseEditAddModal = () => {
        setAddNewAccount(false);
        setIsModalOpen(false)
    }

    const [cardIdOption, setCardIdOption] = useState(-1);

    useEffect(() => {

        if (accountCardsData && accountCardsData.length > 0) {
            const maxCardId = Math.max(...accountCardsData.slice(1).map(option => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);


        }
    }, [accountCardsData]);

    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            // const id = generateUniqueId();
            setRows((oldRows) => [
                ...oldRows,
                {
                    cardId: cardIdOption,
                    name: '',
                    palCode: null,
                    sourceDeductionAssociation: null,
                    email: '',
                    location: '',
                    phoneNumber: '',
                    accountCaseId: '',
                    isNew: true,
                    isEditable: true,
                },
            ]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [cardIdOption]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            }));
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    {t('Add Account')}
                </Button>
                <GridToolbar />
            </GridToolbarContainer>
        );
    }



    const handleSelectRows = (event, selectedIds) => {


        const updatedAccountCardsData = accountCardsData.map(card => {
            if (selectedIds.includes(card.cardId)) {
                return {
                    ...card,
                    selected: !card.selected // Toggle selected field
                };
            }
            return card;
        });

        setAccountCardsData(updatedAccountCardsData);
    };

    const [anySelected, setAnySelected] = useState(false);

    const inputPropsStyle = {
        disableUnderline: true,
        className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
        sx: {
            height: '48px',
            padding: '0 10px',
            borderRadius: '8px',
            background: '#F5F5F6',
            border: '1px solid transparent',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
        },
    };

    const inputStyle = {
        style: {
            textAlign: direction === 'ltr' ? 'left' : 'right',
        },
    };

    const getLocale = () => {
        switch (i18n.language) {
            case 'ar':
                return arSA; // Arabic locale
            case 'he':
                return he; // Hebrew locale
            default:
                return enUS; // Default to English locale
        }
    };

    const fetchEnumsFromAccountCards = async (currentUser, currentToken, currentClient) => {
        await fetchEnums(currentToken, currentClient);
    };

    const fetchEnums = async (currentToken, currentClient, options = {}) => {
        const { backgroundRefresh = false } = options;
        if (!currentClient?.caseId || !currentToken) return;
        if (fetchInFlightRef.current) return;
        fetchInFlightRef.current = true;
        if (!backgroundRefresh) initialLoadDoneRef.current = false;

        const requestKey = `${currentClient.caseId}|${currentClient.accountantId ?? ''}`;
        try {
            await dispatch(fetchAccountCardsTablePageData({
                caseId: currentClient.caseId,
                accountantId: currentClient.accountantId,
                token: currentToken,
                requestKey,
                backgroundRefresh,
            })).unwrap();
            initialLoadDoneRef.current = true;
            setIsClientDataFetched(true);
        } catch (error) {
            console.error(error);
            if (!backgroundRefresh) toast.error(t('fetchEnumsError'), error);
            setIsClientDataFetched(false);
        } finally {
            fetchInFlightRef.current = false;
        }
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const currentUser = UserService.getCurrentUser();
                const currentToken = UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    // Get client data from location.state
                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type)
                        setClient(location.state.client);
                    }
                    const navClient = location.state?.client;
                    if (navClient?.caseId) {
                        const cachedCaseId = accountCardsTablePage?.lastFetchKey?.split('|')?.[0];
                        const hasCachedDataForClient = cachedCaseId && cachedCaseId === String(navClient.caseId)
                            && (accountCardsTablePage?.accountCardsData?.length ?? 0) > 0;
                        if (!hasCachedDataForClient) {
                            dispatch(resetAccountCardsTablePage());
                        }
                        await fetchEnums(currentToken, navClient, { backgroundRefresh: hasCachedDataForClient });
                    }
                }
                else {
                    navigate("/login");
                }
            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
        };
        fetchUserData();
    }, []);

    const handleSavePrefixes = async (prefixEditValuesToSave) => {
        if (!client?.caseId || !token) return;
        const minPrefix = 10; // 2 digits minimum (e.g. 20 → 20001)
        const values = prefixEditValuesToSave ?? {};
        try {
            for (const [palCodeId, value] of Object.entries(values)) {
                const num = parseInt(value, 10);
                if (!Number.isNaN(num) && num >= minPrefix) {
                    await EnumsService.SetPalCodePrefix(client.caseId, palCodeId, num, token);
                }
            }
            await fetchEnums(token, client);
            setPrefixDialogOpen(false);
            toast.success(t('Saved') || 'Saved');
        } catch (e) {
            console.error(e);
            toast.error(t('FailedToSave') || 'Failed to save');
        }
    };

    const filteredAndSortedData = useMemo(() => {

        if (accountCardsData.length <= 0) {
            return [];
        }

        const query = searchQuery.toLowerCase();
        const reservedSet = new Set((reservedAccountCardIds || []).map(String));
        // Apply filtering and scoring
        if (accountCardsData.length <= 0) {
            return [];
        }
        const scoredData = accountCardsData
            .filter((item) => {
                // Hide non-editable cards except reserved system cards
                if (hideNonEditableCards && !item?.isEditable && !reservedSet.has(String(item?.cardId ?? ''))) {
                    return false;
                }
                // Filter by PAL code if selected
                if (selectedPalCode && selectedPalCode.value) {
                    if (item?.palCode !== selectedPalCode.value) {
                        return false;
                    }
                }
                
                // Basic filtering to remove irrelevant items
                return (
                    (item?.cardId?.toString()?.includes(query)) ||
                    (item?.caseId?.toString()?.includes(query)) ||
                    (item?.accountCaseId?.toString()?.includes(query)) ||
                    (item?.name?.toLowerCase()?.includes(query)) ||
                    (item?.palCode?.toLowerCase()?.includes(query)) ||
                    (item?.client?.toString()?.includes(query)) ||
                    (item?.phoneNumber?.toString()?.includes(query)) ||
                    (item?.location?.toLowerCase()?.includes(query)) ||
                    (item?.email?.toLowerCase()?.includes(query)) ||
                    (item?.sourceDeductionAssociation?.toString()?.includes(query))
                );
            })
            .map((item) => {
                // Calculate a relevance score based on the match
                let score = 0;

                if (item?.cardId?.toString() === query) score += 10; // Exact match on cardId
                else if (item?.cardId?.toString()?.includes(query)) score += 5; // Partial match

                if (item?.caseId?.toString() === query) score += 10; // Exact match on caseId
                else if (item?.caseId?.toString()?.includes(query)) score += 5;

                if (item?.accountCaseId?.toString() === query) score += 10;
                else if (item?.accountCaseId?.toString()?.includes(query)) score += 5;

                if (item?.name?.toLowerCase() === query) score += 15; // Give more weight to name exact match
                else if (item?.name?.toLowerCase()?.includes(query)) score += 7;

                if (item?.palCode?.toLowerCase() === query) score += 10;
                else if (item?.palCode?.toLowerCase()?.includes(query)) score += 5;

                if (item?.client?.toString() === query) score += 10;
                else if (item?.client?.toString()?.includes(query)) score += 5;

                if (item?.phoneNumber?.toString() === query) score += 10;
                else if (item?.phoneNumber?.toString()?.includes(query)) score += 5;

                if (item?.location?.toLowerCase() === query) score += 8;
                else if (item?.location?.toLowerCase()?.includes(query)) score += 4;

                if (item?.email?.toLowerCase() === query) score += 10;
                else if (item?.email?.toLowerCase()?.includes(query)) score += 5;

                if (item?.sourceDeductionAssociation?.toString() === query) score += 10;
                else if (item?.sourceDeductionAssociation?.toString()?.includes(query)) score += 5;

                // Return item along with its score
                return { ...item, score };
            });

        // Sort by relevance score (descending)
        let sortedData = scoredData.sort((a, b) => b.score - a.score);

        if (sortByPrefixOrder && palCodePrefixes.length > 0) {
            const prefixMap = palCodePrefixes.reduce((acc, p) => {
                acc[p.palCodeId] = p.prefix;
                return acc;
            }, {});
            sortedData = [...sortedData].sort((a, b) => {
                const orderA = prefixMap[a.palCode] ?? 999999;
                const orderB = prefixMap[b.palCode] ?? 999999;
                if (orderA !== orderB) return orderA - orderB;
                const numA = parseInt(a.cardId, 10) || 0;
                const numB = parseInt(b.cardId, 10) || 0;
                return numA - numB;
            });
        }

        return sortedData;
    }, [accountCardsData, searchQuery, selectedPalCode, hideNonEditableCards, reservedAccountCardIds, sortByPrefixOrder, palCodePrefixes]);

    const palCodeOptionsWithPrefix = useMemo(() => {
        const prefixMap = (palCodePrefixes || []).reduce((acc, p) => {
            acc[p.palCodeId] = p.prefix;
            return acc;
        }, {});
        return (palCodesOptions || []).map(p => ({
            ...p,
            label: `${p.label}${prefixMap[p.value] != null ? ` (${prefixMap[p.value]})` : ''}`,
        }));
    }, [palCodesOptions, palCodePrefixes]);

    const selectedPalCodeOption = useMemo(() => {
        if (!selectedPalCode) return null;
        const found = (palCodeOptionsWithPrefix || []).find(o => o.value === selectedPalCode.value);
        return found != null ? found : selectedPalCode;
    }, [selectedPalCode, palCodeOptionsWithPrefix]);

    useEffect(() => {
        const hasSelected = filteredAndSortedData.some(item => item.selected);
        setAnySelected(hasSelected);
    }, [filteredAndSortedData]);

    useEffect(() => {
        if (filteredAndSortedData) {
            setRows(filteredAndSortedData);
        }
    }, [filteredAndSortedData]);

    const uploadFileToAccountCard = async (file) => {
        try {
            setLocalLoading(true);
            // Store file for later commit
            setUploadedFile(file);
            
            // Call the upload service method to get preview (default behavior)
            const response = await EnumsService.UploadAccountCardsFileData(client.caseId, file, token);

            if (response.ok) {
                const result = await response.json();
                
                // Show preview dialog
                if (result.previewData) {
                    setPreviewData(result.previewData);
                    setIsPreviewDialogVisible(true);
                } else {
                    toast.success(t("FileUploadedSuccessfullyTo"));
                    await fetchEnums(token, client);
                }
            } else {
                // The server responded with an error status
                console.error("File upload failed with response status:", response.status);
                const errorText = await response.text();
                console.error("Error details:", errorText);
                toast.error(t("ErrorUploadingFileTo"));
            }
        } catch (error) {
            console.error("Error uploading file to AccountCards API:", error.message);
            toast.error(t("ErrorUploadingFileTo"));
        }
        setLocalLoading(false);
    };

    const handleConfirmImport = async () => {
        if (!uploadedFile) {
            toast.error(t("NoFileToImport") || "No file to import");
            return;
        }

        try {
            setLocalLoading(true);
            
            // Commit the upload
            const response = await EnumsService.CommitAccountCardsUpload(client.caseId, uploadedFile, token);

            if (response.ok) {
                const result = await response.json();
                
                // Check if there are conflicts that need resolution
                if (result.previewData?.conflicts && result.previewData.conflicts.length > 0) {
                    setUploadConflicts(result.previewData.conflicts);
                    setIsConflictDialogVisible(true);
                    toast.success(t("ImportedWithConflicts") || `Import completed with ${result.previewData.conflicts.length} conflict(s)`);
                } else {
                    toast.success(t("FileUploadedSuccessfullyTo"));
                }
                
                // Close preview dialog
                setIsPreviewDialogVisible(false);
                
                // Refresh the account cards data
                await fetchEnums(token, client);
            } else {
                const errorText = await response.text();
                console.error("Error committing upload:", errorText);
                toast.error(t("ErrorUploadingFileTo"));
            }
        } catch (error) {
            console.error("Error committing upload:", error.message);
            toast.error(t("ErrorUploadingFileTo"));
        } finally {
            setLocalLoading(false);
            setUploadedFile(null);
        }
    };

    const handleShowConflicts = () => {
        // Switch from preview to conflicts
        if (previewData?.conflicts && previewData.conflicts.length > 0) {
            setUploadConflicts(previewData.conflicts);
            setIsConflictDialogVisible(true);
        }
    };

    const handleConflictResolved = async () => {
        // Refresh data after conflicts are resolved
        await fetchEnums(token, client);
        toast.success(t("ConflictsResolved") || "Conflicts resolved successfully");
    };

    const handleFileChange = (event, uploadFunction) => {
        const file = event.target.files[0];
        if (file) {
            uploadFunction(file); // Call the passed upload function with the selected file
        }
    };

    const handleFileButtonClick = (fileInputRef, uploadFunction) => {
        // // Reset the file input value
        fileInputRef.current.value = '';

        // Set up the onchange event handler
        fileInputRef.current.onchange = (event) => handleFileChange(event, uploadFunction);

        // Trigger the file input click
        fileInputRef.current.click();
    };

    const handleExportAccountCards = async () => {
        try {
            let cardIdsToExport = null;
            
            // Start with all account cards or filtered data based on search and PAL code
            let cardsToExport = accountCardsData;
            
            // Apply PAL code filter if selected
            if (selectedPalCode && selectedPalCode.value) {
                cardsToExport = cardsToExport.filter(card => 
                    card.palCode === selectedPalCode.value
                );
            }
            
            // Apply search query filter if there's a search query
            if (searchQuery && searchQuery.trim() !== '') {
                const query = searchQuery.toLowerCase();
                cardsToExport = cardsToExport.filter((item) => {
                    return (
                        (item?.cardId?.toString()?.includes(query)) ||
                        (item?.caseId?.toString()?.includes(query)) ||
                        (item?.accountCaseId?.toString()?.includes(query)) ||
                        (item?.name?.toLowerCase()?.includes(query)) ||
                        (item?.palCode?.toLowerCase()?.includes(query)) ||
                        (item?.client?.toString()?.includes(query)) ||
                        (item?.phoneNumber?.toString()?.includes(query)) ||
                        (item?.location?.toLowerCase()?.includes(query)) ||
                        (item?.email?.toLowerCase()?.includes(query)) ||
                        (item?.sourceDeductionAssociation?.toString()?.includes(query))
                    );
                });
            }
            
            // If rows are selected and no PAL code/search filter is applied, use selected rows
            // Otherwise, use the filtered cards
            if (selectedRows.length > 0 && !selectedPalCode && (!searchQuery || searchQuery.trim() === '')) {
                cardIdsToExport = selectedRows.map(id => id.toString());
            } else if (cardsToExport.length > 0) {
                // Export the filtered cards (by PAL code and/or search query)
                cardIdsToExport = cardsToExport.map(card => card.cardId.toString());
            }
            // If no filters and no selection, export all (cardIdsToExport remains null)
            
            await EnumsService.ExportAccountCards(client.caseId, client.accountantId, token, cardIdsToExport);
        } catch (error) {
            console.error("Error exporting account cards:", error);
        }
    };

    const handleSelectionModelChange = (ids) => {
        setSelectedRows(ids);
    };

    const generateUniqueId = () => {
        return Date.now().toString();
    };
    const isRowSelectable = (params) => {
        const { row } = params;
        return row.isEditable;
    };

    const handleEdit = (id, params) => {


        setOldCard(params.row.cardId.toString());
        setSelectedRow(params.row);
        setIsNew(false); // It's an edit action
        setIsModalOpen(true);
    };

    const handleRowDoubleClick = (params) => {
        handleEdit(params.id, params);
    };

    const handleSaveClick = (id) => () => {

        setRowModesModel((prevModel) => ({
            ...prevModel,
            [id]: { mode: GridRowModes.View },
        }));
    };
    const saveFunction = async (updatedRow) => {


        // // Implement your API call for saving edited data
        // try {
        //     // Example API call
        //     await api.updateRow(updatedRow);
        //     
        // } catch (error) {
        //     console.error('Error updating row:', error);
        // }
    };


    const handleCancelClick = (id) => () => {
        setRowModesModel((prevModel) => ({
            ...prevModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));

        const editedRow = rows.find((row) => row.cardId === id);
        if (editedRow.isNew) {
            setRows((prevRows) => prevRows.filter((row) => row.cardId !== id));
        }
    };

    const processRowUpdate = async (newRow, oldRow) => {

        const updatedRow = { ...newRow, isNew: false };
        // Validate email and phone number
        if (newRow.email && newRow.email !== '') {
            if (!validateEmail(newRow.email)) {

                toast.error(t('InvalidEmailAddress'));
                return oldRow; // Revert to old row if validation fails
            }
        }
        if (newRow.phoneNumber && newRow.phoneNumber !== '') {

            if (newRow.phoneNumber !== '' && !validateNumber(newRow.phoneNumber)) {
                toast.error(t('InvalidPhoneNumber'));
                return oldRow; // Revert to old row if validation
            }
        }

        try {
            if (newRow.isNew) {
                // Call handleSaveNewAccount for new rows
                await handleSaveNewAccount(updatedRow);
            } else {
                // Call updateAccountCard for existing rows

                await updateAccountCard(updatedRow, oldRow);
            }

            // Update the rows state with the updated row
            setRows((prevRows) =>
                prevRows.map((row) => (row.cardId === updatedRow.cardId ? updatedRow : row))
            );

            return updatedRow;
        } catch (error) {
            console.error('Error processing row update:', error);

            // Remove the row if it is new and an exception occurred
            if (newRow.isNew) {
                setRows((prevRows) => prevRows.filter((row) => row.cardId !== newRow.cardId));
            }

            // Return oldRow to revert changes in the grid
            return oldRow;
        }
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };
    const updateAccountCard = async (updatedAccountCard, oldCard) => {
        try {


            // Ensure empty string fields are converted to null
            Object.entries(updatedAccountCard).forEach(([key, value]) => {
                if (value === '') {
                    updatedAccountCard[key] = null;
                }
            });





            // Call the API to update the account card
            const response = await EnumsService.UpdateAccountCard(
                client.caseId,
                oldCard.cardId,
                oldCard.name,
                updatedAccountCard.cardId.toString(),
                updatedAccountCard.name,
                updatedAccountCard.accountCaseId,
                updatedAccountCard.palCode,
                token,
                updatedAccountCard.phoneNumber,
                updatedAccountCard.location,
                updatedAccountCard.email,
                updatedAccountCard.sourceDeductionAssociation,
                oldCard.caseId,
                oldCard.isEditable,
                updatedAccountCard.exactOccupation,
                parseInt(updatedAccountCard.deductionType),
                updatedAccountCard.taxAssessor,
                updatedAccountCard.deductionValidity,
                updatedAccountCard.deductionRate,
                updatedAccountCard.externalSoftwareCardNumber,
                // Only include SortCode and AutoProcessed for accountants
                userTypeContext?.toString() === Constants.UserType.Accountant ? updatedAccountCard.sortCodeId : null,
                userTypeContext?.toString() === Constants.UserType.Accountant ? updatedAccountCard.autoProcessed : false,
                null,
                null,
                null,
                userTypeContext?.toString() === Constants.UserType.Accountant ? (updatedAccountCard.frequency ?? null) : null
            );
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || t('FailedToUpdateAccountCard'));
            }
            fetchEnums(token, client);
            // If no errors, show a success toast
            toast.success(t('AccountCardUpdated'));
        } catch (error) {
            console.error('Error saving account card:', error);
            // Show error toast if the update fails
            toast.error(t('FailedToUpdateAccountCard'));
        }
    };

    const handleDeleteClick = (id) => () => {
        setItemIdToDelete(id);
        setDeleteModalVisible(true);
        // setRows((prevRows) => prevRows.filter((row) => row.cardId !== id));
    };

    const handleSetEditable = (cardId) => async () => {
        if (!client?.caseId || !token) return;
        try {
            const res = await EnumsService.SetAccountCardEditable(client.caseId, cardId, true, token);
            if (res.ok) {
                toast.success(t('CardSetEditable') || 'Card set as editable');
                const accountCardsResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
                if (accountCardsResponse.ok) {
                    const data = await accountCardsResponse.json();
                    setAccountCardsData(data);
                }
            } else {
                const text = await res.text();
                toast.error(text || t('FailedToSetEditable') || 'Failed to set editable');
            }
        } catch (e) {
            toast.error(t('FailedToSetEditable') || 'Failed to set editable');
        }
    };

    const handleNavigateToDashboard = (id) => () => {
        const accountCard = rows.find((row) => row.cardId === id); // Use `find` since `cardId` is likely unique

        const startDate = new Date();
        startDate.setDate(1); // Set to the first day
        startDate.setHours(0, 0, 0, 0); // Reset time to the start of the day

        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1); // Move to the next month
        endDate.setDate(0); // Roll back to the last day of the current month
        endDate.setHours(23, 59, 59, 999); // Set time to the end of the day


        navigate('/AccountCardDashboard', {
            state: {
                client,
                accountCardId: accountCard.cardId,
                accountCardName: accountCard.name,
                palCodeName: accountCard.palCode !== '' ? accountCard.palCode : 'NonPalCode',
                startDate: startDate,
                endDate: endDate,
                isSortCodeReport: true,
                breadcrumbs: ['Reports', 'LedgerReport'],
            },
        });


    };

    const handleConfirmDelete = async () => {
        try {
            const response = await EnumsService.DeleteAccountCardsbyCaseId(client.caseId, itemIdToDelete, token);

            if (response.ok) {
                toast.success(t("Account card deleted successfully"));
                setDeleteModalVisible(false);
                fetchEnums(token, client); // Fetch updated enums after the delete action
            } else {
                const errorMessage = await response.text(); // Extract the error message from the response body
                if (errorMessage.includes("Account card can't be deleted, documents with account card exist")) {
                    toast.error(t('AccountCardCannotBeDeleted'));
                } else {
                    toast.error(t('TaskFailed'));
                }
            }

        } catch (error) {
            if (error?.response?.data?.includes("Account card can't be deleted, documents with account card exist")) {
                toast.error(t('AccountCardCannotBeDeleted'));
            } else {
                toast.error(t('TaskFailed'));
            }
            console.error(t('TaskFailed'));
        }
    };

    const handleOpenBulkDeleteSelected = () => {
        if (!selectedRows.length) return;
        setBulkDeleteCardIds(selectedRows.map((id) => String(id)));
        setBulkDeleteModalVisible(true);
    };

    const runBulkDeleteAccountCards = async (cardIds, { closeBulkConfirm = true, closeZeroTx = false } = {}) => {
        if (!client?.caseId || !token || !cardIds?.length) {
            if (closeBulkConfirm) {
                setBulkDeleteModalVisible(false);
                setBulkDeleteCardIds([]);
            }
            if (closeZeroTx) {
                setZeroTxDeleteModalOpen(false);
                setZeroTxCards([]);
            }
            return;
        }
        setBulkDeleteProcessing(true);
        try {
            const response = await EnumsService.BulkDeleteAccountCards(
                client.caseId,
                cardIds.map((id) => String(id)),
                token
            );
            if (!response.ok) {
                const errText = await response.text();
                toast.error(errText || t('TaskFailed'));
                if (closeBulkConfirm) {
                    setBulkDeleteModalVisible(false);
                    setBulkDeleteCardIds([]);
                }
                return;
            }
            const data = await response.json();
            const deleted = data.deletedCardIds ?? data.DeletedCardIds ?? [];
            const failures = data.failures ?? data.Failures ?? [];
            const successCount = deleted.length;
            let blocked = 0;
            let otherFail = 0;
            for (const f of failures) {
                const r = f.reason ?? f.Reason ?? '';
                if (r.includes("Account card can't be deleted, documents with account card exist")) {
                    blocked += 1;
                } else {
                    otherFail += 1;
                }
            }

            if (closeBulkConfirm) {
                setBulkDeleteModalVisible(false);
                setBulkDeleteCardIds([]);
            }
            if (closeZeroTx) {
                setZeroTxDeleteModalOpen(false);
                setZeroTxCards([]);
            }
            setSelectedRows([]);
            await fetchEnums(token, client);

            const formatFailureLine = (f) => {
                const id = f.cardId ?? f.CardId ?? '';
                const reason = f.reason ?? f.Reason ?? '';
                const msg = reason.includes('documents with account card')
                    ? t('AccountCardCannotBeDeleted')
                    : reason;
                return `${id}: ${msg}`;
            };

            if (failures.length === 0) {
                toast.success(t('AccountCardsBulkDeletedSuccess', { count: successCount }));
            } else {
                const detailLines = failures.map(formatFailureLine).join('\n');
                const headline =
                    successCount > 0
                        ? t('AccountCardsBulkDeletedPartial', {
                              success: successCount,
                              failed: failures.length,
                          })
                        : blocked > 0 && otherFail === 0
                          ? t('AccountCardCannotBeDeleted')
                          : t('TaskFailed');
                toast.warning(`${headline}\n\n${detailLines}`, {
                    autoClose: 16000,
                    style: { whiteSpace: 'pre-line' },
                });
            }
        } catch {
            toast.error(t('TaskFailed'));
        } finally {
            setBulkDeleteProcessing(false);
        }
    };

    const handleConfirmBulkDelete = async () => {
        await runBulkDeleteAccountCards(bulkDeleteCardIds, { closeBulkConfirm: true });
    };

    const handleOpenZeroTransactionDelete = async () => {
        if (!client?.caseId || !token) return;
        setZeroTxDeleteModalOpen(true);
        setZeroTxLoading(true);
        setZeroTxCards([]);
        try {
            const response = await EnumsService.GetAccountCardsWithoutTransactions(
                client.caseId,
                token
            );
            if (!response.ok) {
                const errText = await response.text();
                toast.error(errText || t('TaskFailed'));
                setZeroTxDeleteModalOpen(false);
                return;
            }
            const data = await response.json();
            const cards = (Array.isArray(data) ? data : []).map((c) => ({
                cardId: c.cardId ?? c.CardId,
                name: c.name ?? c.Name,
                palCode: c.palCode ?? c.PalCode,
            }));
            setZeroTxCards(cards);
        } catch {
            toast.error(t('TaskFailed'));
            setZeroTxDeleteModalOpen(false);
        } finally {
            setZeroTxLoading(false);
        }
    };

    const handleConfirmZeroTransactionDelete = async (cardIds) => {
        await runBulkDeleteAccountCards(cardIds, { closeBulkConfirm: false, closeZeroTx: true });
    };

    const sourceDeductionOptions = [
        { key: 'NotIncluded', label: t('NotIncluded'), value: 0 },
        { key: 'Included', label: t('Included'), value: 1 }
    ];

    const exactOccupationOptions = [
        { key: 0, label: 'כללי', value: 0 },
        { key: 1, label: 'חברה', value: 1 },
        { key: 2, label: 'עצמאי', value: 2 },
        { key: 3, label: 'מלכ"ר', value: 3 }
    ];


    const deductionTypeOptions = [
        { key: 1, label: 'ריבית והפרשי הצמדה', value: 1 },
        { key: 2, label: 'עמלות ביטוח', value: 2 },
        { key: 3, label: 'שכר סופרים אומנים', value: 3 },
        { key: 6, label: 'שירותים או נכסים', value: 6 },
        { key: 7, label: 'תושב חוץ-ניכוי ע"י המנכה', value: 7 },
        { key: 8, label: 'תושב חוץ-ניכוי ע"י הבנק', value: 8 },
        { key: 11, label: 'קופת גמל שלא כדין', value: 11 },
        { key: 12, label: 'החזר למעביד מפיצויים', value: 12 },
        { key: 13, label: 'שכירות מקרקעין', value: 13 },
        { key: 14, label: 'קרן השתלמות לעצמאי', value: 14 },
        { key: 15, label: 'הימורים והגרלות', value: 15 },
        { key: 18, label: 'דיבידנד', value: 18 }
    ];


    const [addNewAccount, setAddNewAccount] = useState(false);
    const [newAccountCard, setNewAccountCard] = useState({
        cardId: '',
        caseId: '',
        phoneNumber: '',
        location: '',
        email: '',
        sourceDeduction: null,
        palCode: null,
        name: '',
    });
    useEffect(() => {
        if (addNewAccount) {
            // // const id = generateUniqueId();
            // setRows((prevRows) => [
            //     {
            //         cardId: cardIdOption,
            //         name: '',
            //         palCode: null,
            //         sourceDeductionAssociation: null,
            //         email: '',
            //         location: '',
            //         phoneNumber: '',
            //         accountCaseId: '',
            //         isNew: true,
            //         isEditable: true,
            //     },
            //     ...prevRows,
            // ]);
            // setRowModesModel((prevModel) => ({
            //     ...prevModel,
            //     [cardIdOption]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            // }));
            // setAddNewAccount(false);
            setSelectedRow({
                cardId: cardIdOption,
                name: '',
                palCode: null,
                sourceDeductionAssociation: null,
                email: '',
                location: '',
                phoneNumber: '',
                accountCaseId: '',
            });
            setIsNew(true); // It's an add action
            setIsModalOpen(true);
        }
    }, [addNewAccount]);


    const handleInputChange = (field, value) => {
        setNewAccountCard((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleCancelAddAccount = () => {
        setAddNewAccount(false);
        setNewAccountCard({
            cardId: '',
            caseId: '',
            phoneNumber: '',
            location: '',
            email: '',
            sourceDeduction: null,
            palCode: null,
            name: '',
        });
    };

    const handleSaveNewAccount = async (newAccountCard) => {



        const response = await EnumsService.AddAccountCard(
            client.caseId,
            newAccountCard.cardId.toString(),
            newAccountCard.name,
            newAccountCard.accountCaseId,
            newAccountCard.palCode,
            token,
            newAccountCard.phoneNumber,
            newAccountCard.location,
            newAccountCard.email,
            newAccountCard.sourceDeductionAssociation,
            true,
            newAccountCard.exactOccupation,
            newAccountCard.deductionType,
            newAccountCard.taxAssessor,
            newAccountCard.deductionValidity,
            newAccountCard.deductionRate,
            newAccountCard.externalSoftwareCardNumber,
            // Only include SortCode and AutoProcessed for accountants
            userTypeContext?.toString() === Constants.UserType.Accountant ? newAccountCard.sortCodeId : null,
            userTypeContext?.toString() === Constants.UserType.Accountant ? newAccountCard.autoProcessed : false,
            null,
            null,
            null,
            userTypeContext?.toString() === Constants.UserType.Accountant ? (newAccountCard.frequency ?? null) : null
        );

        if (!response.ok) {
            // Throw an error if the response is not successful
            toast.error(t('FailedToAddAccountCard'))
            const errorText = await response.text();
            throw new Error(errorText || t('FailedToAddAccountCard'));
        }

        // If the request is successful, display a success toast
        toast.success(t('AddedAccountCardSuccessfully'));

        // Hide the form after saving
        fetchEnums(token, client);
        setAddNewAccount(false);
    };

    const handleMerge = async (newCard, oldCard) => {
        try {
            // Await the merge call
            
            const response = await EnumsService.MergeAccountCards(client.caseId, newCard, oldCard, token);

            if (response.ok) {
                fetchEnums(token, client);
                toast.success(t('MergeSuccessful'));
            } else {
                const errorMessage = await response.text();
                console.error('Error Merging:', errorMessage);
                toast.error(t('FailedToMerge'));
            }
        } catch (error) {
            console.error('Error Merging:', error);
            toast.error(t('FailedToMerge'));
        }
    };

    const handleBatchMerge = async (batchMergeData, options = {}) => {
        const { closeBatchModal = true } = options;
        try {
            const response = await EnumsService.BatchMergeAccountCards(
                client.caseId,
                batchMergeData.mergeOperations,
                batchMergeData.deleteOldCards,
                token
            );

            if (response.ok) {
                const result = await response.json();
                fetchEnums(token, client);
                
                // Show detailed results with SweetAlert
                const Swal = require('sweetalert2');
                
                Swal.fire({
                    title: t('MergeResults'),
                    html: `
                        <div style="direction: rtl; text-align: right; max-height: 70vh; overflow-y: auto;">
                            <div style="margin-bottom: 10px;">
                                <div style="padding: 8px; background-color: #d4edda; border-radius: 6px; margin-bottom: 6px;">
                                    <strong style="color: #155724; font-size: 13px;">✓ ${t('SuccessfulOperations')}: ${result.successCount || 0}</strong>
                                </div>
                                ${result.failureCount > 0 ? `
                                    <div style="padding: 8px; background-color: #f8d7da; border-radius: 6px;">
                                        <strong style="color: #721c24; font-size: 13px;">✗ ${t('FailedOperations')}: ${result.failureCount}</strong>
                                    </div>
                                ` : ''}
                            </div>
                            
                            <div style="max-height: 50vh; overflow-y: auto;">
                                ${(result.results || []).map((res, index) => `
                                    <div style="padding: 8px; margin: 6px 0; border: 1px solid #ddd; border-radius: 6px; background: ${res.success ? '#f8fff8' : '#fff8f8'}; text-align: right; direction: rtl;">
                                        <strong style="font-size: 12px;">${t('Operation')} ${index + 1}: ${res.baseCardName || res.baseCardId}</strong>
                                        ${res.mergedCards ? `
                                            <ul style="margin: 5px 0; padding-right: 20px; padding-left: 0; font-size: 11px; list-style-position: inside;">
                                                ${res.mergedCards.map(card => `
                                                    <li style="color: ${card.success ? 'green' : 'red'}; text-align: right;">
                                                        <strong>${card.cardName || card.cardId}</strong> (${card.cardId}): ${card.message === 'MergedSuccessfully' ? t('MergedSuccessfully') : card.message}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : `<p style="color: red; font-size: 11px; text-align: right;">${res.message || ''}</p>`}
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                    `,
                    icon: result.failureCount === 0 ? 'success' : 'warning',
                    confirmButtonText: t('Close'),
                    width: '90%',
                    maxWidth: '600px',
                    customClass: {
                        popup: 'swal2-rtl',
                        htmlContainer: 'swal2-rtl'
                    }
                });

                if (closeBatchModal) {
                    setBatchMergeModalVisible(false);
                }
                return true;
            } else {
                const errorMessage = await response.text();
                console.error('Error Batch Merging:', errorMessage);
                toast.error(t('FailedToBatchMerge') || 'Failed to perform batch merge');
                return false;
            }
        } catch (error) {
            console.error('Error Batch Merging:', error);
            toast.error(t('FailedToBatchMerge') || 'Failed to perform batch merge');
            return false;
        }
    };

    const handleOpenEditSelected = () => {
        setOpenEditSelected(true);
    };

    const handleCloseEditSelected = () => {
        setSelectedPalCodeForSelectAll('');
        setSelectedSortCodeForSelectAll('');
        setSelectedAutoProcessedForSelectAll(false);
        setSelectedSourceDeductionForSelectAll('');
        setSelectedDeductionTypeForSelectAll('');
        setSelectedTaxAssessorForSelectAll('');
        setSelectedDeductionRateForSelectAll('');
        setSelectedDeductionValidityForSelectAll('');
        setSelectedIncludeInCashFlowForSelectAll(false);
        setSelectedCashFlowCodeForSelectAll('');
        setSelectedCashFlowAverageAmountForSelectAll('');
        setOpenEditSelected(false);
    };

    /** Card IDs that are not editable and not reserved (only these are sent to bulk). */
    const getCardIdsToMakeEditableFromSelected = useMemo(() => {
        const reservedSet = new Set((reservedAccountCardIds || []).map(String));
        const rowsById = (rows || []).reduce((acc, r) => {
            acc[String(r.cardId)] = r;
            return acc;
        }, {});
        return selectedRows
            .filter((id) => {
                const row = rowsById[String(id)];
                return row && !row.isEditable && !reservedSet.has(String(id));
            })
            .map((id) => String(id));
    }, [rows, selectedRows, reservedAccountCardIds]);

    /** All card IDs in case that are not editable and not reserved. */
    const getCardIdsToMakeEditableFromAll = useMemo(() => {
        const reservedSet = new Set((reservedAccountCardIds || []).map(String));
        return (accountCardsData || [])
            .filter((c) => !c.isEditable && !reservedSet.has(String(c.cardId ?? '')))
            .map((c) => String(c.cardId));
    }, [accountCardsData, reservedAccountCardIds]);

    const selectedCardsForMerge = useMemo(() => {
        if (!selectedRows.length) return [];
        const idSet = new Set(selectedRows.map(String));
        return (accountCardsData || []).filter((c) => idSet.has(String(c.cardId)));
    }, [selectedRows, accountCardsData]);

    const handleOpenMergeSelected = () => {
        if (selectedRows.length < 2) {
            toast.info(t('NeedAtLeastTwoCards'));
            return;
        }
        setMergeSelectedModalVisible(true);
    };

    const handleMergeSelectedConfirm = async (payload) => {
        if (!client?.caseId || !token) return;
        setMergeSelectedProcessing(true);
        try {
            const ok = await handleBatchMerge(
                {
                    mergeOperations: [{
                        baseCardId: payload.baseCardId,
                        cardsToMerge: payload.cardsToMerge,
                    }],
                    deleteOldCards: payload.deleteOldCards,
                },
                { closeBatchModal: false }
            );
            if (ok) {
                setMergeSelectedModalVisible(false);
                setSelectedRows([]);
            }
        } finally {
            setMergeSelectedProcessing(false);
        }
    };

    /** Run make-selected editable (called after confirm). Sends only non-editable, non-reserved cards. */
    const runMakeSelectedEditable = async () => {
        const cardIds = getCardIdsToMakeEditableFromSelected;
        if (cardIds.length === 0 || !client?.caseId || !token) {
            toast.info(t('NoCardsToMakeEditable') || 'No non-editable selected cards to update (excluding reserved).');
            return;
        }
        setLocalLoading(true);
        try {
            const { successCount, errors } = await AccountCardService.setAccountCardsEditableBulk(
                client.caseId,
                cardIds,
                true,
                token
            );
            if (errors.length > 0) {
                toast.error(
                    t('MakeEditablePartialError') || `${successCount} updated; ${errors.length} failed.`
                );
            } else {
                toast.success(
                    t('MakeEditableSuccess') || `${successCount} card(s) are now editable.`
                );
            }
            await fetchEnums(token, client);
            setSelectedRows([]);
        } catch (err) {
            console.error('Make selected editable failed:', err);
            toast.error(t('MakeEditableFailed') || 'Failed to make selected cards editable');
        } finally {
            setLocalLoading(false);
        }
    };

    /** Run make-all editable (called after confirm). Sends only non-editable, non-reserved cards. */
    const runMakeAllEditable = async () => {
        const cardIds = getCardIdsToMakeEditableFromAll;
        if (cardIds.length === 0 || !client?.caseId || !token) {
            toast.info(t('NoCardsToMakeEditable') || 'No non-editable cards to update (excluding reserved).');
            return;
        }
        setLocalLoading(true);
        try {
            const { successCount, errors } = await AccountCardService.setAccountCardsEditableBulk(
                client.caseId,
                cardIds,
                true,
                token
            );
            if (errors.length > 0) {
                toast.warning(
                    t('MakeEditablePartialError') || `${successCount} updated; ${errors.length} failed.`
                );
            } else {
                toast.success(
                    t('MakeAllEditableSuccess') || `${successCount} card(s) are now editable.`
                );
            }
            await fetchEnums(token, client);
        } catch (err) {
            console.error('Make all editable failed:', err);
            toast.error(t('MakeEditableFailed') || 'Failed to make cards editable');
        } finally {
            setLocalLoading(false);
        }
    };

    const handleMakeSelectedEditable = () => {
        if (selectedRows.length === 0 || !client?.caseId || !token) {
            toast.error(t('NoAccountCardsAvailable') || 'Select at least one card');
            return;
        }
        const count = getCardIdsToMakeEditableFromSelected.length;
        if (count === 0) {
            toast.info(t('NoCardsToMakeEditable') || 'Selected cards are already editable or reserved.');
            return;
        }
        setMakeEditableConfirmPayload({ type: 'selected', count });
        setMakeEditableConfirmOpen(true);
    };

    const handleMakeAllEditable = () => {
        if (!client?.caseId || !token || !accountCardsData?.length) {
            toast.error(t('NoAccountCardsAvailable') || 'No account cards to update');
            return;
        }
        const count = getCardIdsToMakeEditableFromAll.length;
        if (count === 0) {
            toast.info(t('NoCardsToMakeEditable') || 'All cards are already editable or reserved.');
            return;
        }
        setMakeEditableConfirmPayload({ type: 'all', count });
        setMakeEditableConfirmOpen(true);
    };

    const handleMakeEditableConfirm = () => {
        setMakeEditableConfirmOpen(false);
        const payload = makeEditableConfirmPayload;
        setMakeEditableConfirmPayload(null);
        if (payload?.type === 'selected') runMakeSelectedEditable();
        else if (payload?.type === 'all') runMakeAllEditable();
    };

    const handleMakeEditableConfirmClose = () => {
        setMakeEditableConfirmOpen(false);
        setMakeEditableConfirmPayload(null);
    };

    const handleEditInBulk = async () => {
        // Ensure there's at least one selected item
        if (selectedRows.length === 0) {
            return;
        }

        const CaseId = client.caseId;
        let palCodeSuccess = true;
        let sortCodeSuccess = true;

        try {
            // Update PAL Code if selected
            if (selectedPalCodeForSelectAll) {
                const palCodeResponse = await EnumsService.EditInBulk(CaseId, selectedRows, selectedPalCodeForSelectAll, token);
                if (!palCodeResponse.ok) {
                    palCodeSuccess = false;
                    const errorText = await palCodeResponse.text();
                    console.error('PAL Code update error:', errorText);
                }
            }

            // Update Sort Code and Auto Processed if user is not a client and values are provided
            if (userTypeContext?.toString() !== Constants.UserType.Client && 
                (selectedSortCodeForSelectAll || selectedAutoProcessedForSelectAll)) {
                const sortCodeResponse = await EnumsService.EditSortCodeInBulk(
                    CaseId, 
                    selectedRows, 
                    selectedSortCodeForSelectAll, 
                    selectedAutoProcessedForSelectAll, 
                    token
                );
                if (!sortCodeResponse.ok) {
                    sortCodeSuccess = false;
                    const errorText = await sortCodeResponse.text();
                    console.error('Sort Code update error:', errorText);
                }
            }

            // Update Source Deduction Association, Deduction Type, TaxAssessor, DeductionRate, DeductionValidity if values are provided
            let deductionSuccess = true;
            const hasSourceDeduction = selectedSourceDeductionForSelectAll !== '' && selectedSourceDeductionForSelectAll !== null && selectedSourceDeductionForSelectAll !== undefined;
            const hasDeductionType = selectedDeductionTypeForSelectAll !== '' && selectedDeductionTypeForSelectAll !== null && selectedDeductionTypeForSelectAll !== undefined;
            const hasTaxAssessor = selectedTaxAssessorForSelectAll !== '' && selectedTaxAssessorForSelectAll !== null && selectedTaxAssessorForSelectAll !== undefined;
            const hasDeductionRate = selectedDeductionRateForSelectAll !== '' && selectedDeductionRateForSelectAll !== null && selectedDeductionRateForSelectAll !== undefined;
            const hasDeductionValidity = selectedDeductionValidityForSelectAll !== '' && selectedDeductionValidityForSelectAll !== null && selectedDeductionValidityForSelectAll !== undefined;
            if (hasSourceDeduction || hasDeductionType || hasTaxAssessor || hasDeductionRate || hasDeductionValidity) {
                const deductionRateNum = hasDeductionRate ? (parseFloat(selectedDeductionRateForSelectAll) || null) : null;
                const deductionResponse = await EnumsService.EditDeductionInBulk(
                    CaseId,
                    selectedRows,
                    hasSourceDeduction ? selectedSourceDeductionForSelectAll : null,
                    hasDeductionType ? selectedDeductionTypeForSelectAll : null,
                    hasTaxAssessor ? selectedTaxAssessorForSelectAll : null,
                    deductionRateNum,
                    hasDeductionValidity ? selectedDeductionValidityForSelectAll : null,
                    token
                );
                if (!deductionResponse.ok) {
                    deductionSuccess = false;
                    const errorText = await deductionResponse.text();
                    console.error('Deduction update error:', errorText);
                }
            }

            // Update Payment Terms if a type was chosen
            let paymentTermsSuccess = true;
            const hasPaymentTerms = selectedPaymentTermsTypeForSelectAll !== '' && selectedPaymentTermsTypeForSelectAll !== null && selectedPaymentTermsTypeForSelectAll !== undefined;
            if (hasPaymentTerms) {
                const ptType = Number(selectedPaymentTermsTypeForSelectAll);
                let ptDays = null;
                if (ptType === Constants.PaymentTermsType.Custom) {
                    ptDays = selectedPaymentTermsDaysForSelectAll !== '' ? parseInt(selectedPaymentTermsDaysForSelectAll, 10) : null;
                } else if (ptType === Constants.PaymentTermsType.Shoteff) {
                    ptDays = null;
                } else {
                    ptDays = ptType;
                }
                const paymentTermsResponse = await EnumsService.EditPaymentTermsInBulk(
                    CaseId,
                    selectedRows,
                    ptType,
                    ptDays,
                    token
                );
                if (!paymentTermsResponse.ok) {
                    paymentTermsSuccess = false;
                    const errorText = await paymentTermsResponse.text();
                    console.error('Payment terms update error:', errorText);
                }
            }

            // Assign the cash-flow configuration when the forecast checkbox was used.
            // Unchecking it and saving removes the selected cards from the forecast.
            let cashFlowSuccess = true;
            const hasCashFlowChange =
                selectedIncludeInCashFlowForSelectAll ||
                (selectedCashFlowCodeForSelectAll !== '' && selectedCashFlowCodeForSelectAll !== null);
            if (hasCashFlowChange) {
                const cashFlowResponse = await CashFlowForecastService.UpdateConfiguration(
                    {
                        CaseId,
                        CardIds: selectedRows,
                        IncludeInCashFlow: Boolean(selectedIncludeInCashFlowForSelectAll),
                        CashFlowCode:
                            selectedIncludeInCashFlowForSelectAll && selectedCashFlowCodeForSelectAll !== ''
                                ? Number(selectedCashFlowCodeForSelectAll)
                                : null,
                        CashFlowAverageAmount:
                            selectedIncludeInCashFlowForSelectAll
                            && selectedCashFlowAverageAmountForSelectAll !== ''
                                ? Number(selectedCashFlowAverageAmountForSelectAll)
                                : null,
                        CashFlowCurrency: null,
                    },
                    token
                );
                if (!cashFlowResponse.ok) {
                    cashFlowSuccess = false;
                    const errorText = await cashFlowResponse.text();
                    console.error('Cash flow configuration update error:', errorText);
                }
            }

            if (palCodeSuccess && sortCodeSuccess && deductionSuccess && paymentTermsSuccess && cashFlowSuccess) {
                toast.success(t("AccountCardsUpdatedSuccessfully"));
                await fetchEnums(token, client);
            } else {
                toast.error(t("AccountCardsFailedToUpdate"));
            }
        } catch (error) {
            console.error('Bulk edit error:', error);
            toast.error(t("AccountCardsFailedToUpdate"));
        }

        setSelectedRows([]);
        handleCloseEditSelected();
    };


    const handleModalSave = async (editedData, isNew) => {

        if (isNew) {
            // Call API to add new account card
            await handleSaveNewAccount(editedData);
        } else {
            // Call API to update existing account card
            const OldCard = accountCardsData.find((card) => card.cardId === oldCard);

            await updateAccountCard(editedData, OldCard);
        }
        // Refresh data
        await fetchEnums(token, client);
    };


    // Helper function to get document status (1 = has docs, 0 = no docs)
    const getDocumentStatus = (row) => {
        if (!row || !row.documentUrls) {
            return 0;
        }
        let documentUrls = [];
        if (typeof row.documentUrls === 'string') {
            try {
                documentUrls = JSON.parse(row.documentUrls);
            } catch (e) {
                documentUrls = [];
            }
        } else if (Array.isArray(row.documentUrls)) {
            documentUrls = row.documentUrls;
        }
        return documentUrls && documentUrls.length > 0 ? 1 : 0;
    };

    const columns = [
        {
            field: 'cardId',
            headerName: t('AccountCard ID'),
            textAlign: 'center',
            headerAlign: 'center',
            editable: true,
            flex: 1,
            viewTier: 'priority',
            sortComparator: (v1, v2) => {
                const intV1 = parseInt(v1, 10) || 0;
                const intV2 = parseInt(v2, 10) || 0;
                return intV1 - intV2;
            },
        },
        {
            field: 'name',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('AccountCard Name'),
            editable: true,
            flex: 1,
            viewTier: 'priority',
        },
        {
            field: 'palCode',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('PalCode'),
            editable: true,
            flex: 1,
            viewTier: 'priority',
        },
        {
            field: 'sourceDeductionAssociation',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('SourceDeductionAssociation'),
            editable: true,
            flex: 1,
            viewTier: 'compact',
            renderCell: (params) => (
                <span>{params.value ? t('Included') : t('NotIncluded')}</span>
            ),
        },
        {
            field: 'email',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('Email'),
            editable: true,
            width: 200,
            viewTier: 'compact',
        },
        {
            field: 'taxAssessor',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('TaxAssessor'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
            renderCell: (params) => {
                const option = Constants.TaxAssessorOptionsString.find((opt) => opt.value === params.value);
                return <span>{option ? option.label : params.value || '-'}</span>;
            },
        },
        {
            field: 'location',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('Location'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
        },
        {
            field: 'deductionValidity',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('DeductionValidity'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
            renderCell: (params) => {
                if (!params.value) return <span>-</span>;
                try {
                    const date = new Date(params.value);
                    return <span>{date.toLocaleDateString()}</span>;
                } catch (e) {
                    return <span>{params.value}</span>;
                }
            },
        },
        {
            field: 'phoneNumber',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('PhoneNumber'),
            editable: true,
            flex: 1,
            viewTier: 'compact',
        },
        {
            field: 'accountCaseId',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('CompanyId'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
        },
        {
            field: 'deductionType',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('DeductionType'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
            renderCell: (params) => {
                const option = Constants.DeductionTypeOptions.find((opt) => opt.value === params.value);
                return <span>{option ? option.label : ''}</span>;
            },
        },
        {
            field: 'deductionRate',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('DeductionRate'),
            editable: true,
            flex: 1,
            viewTier: 'standard',
            renderCell: (params) => (
                <span>{params.value != null && params.value !== '' ? params.value : '-'}</span>
            ),
        },
        {
            field: 'exactOccupation',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('ExactOccupation'),
            editable: true,
            flex: 1,
            viewTier: 'full',
        },
        {
            field: 'externalSoftwareCardNumber',
            textAlign: 'center',
            headerAlign: 'center',
            headerName: t('ExternalSoftwareCardNumber'),
            editable: true,
            flex: 1,
            viewTier: 'full',
        },
        ...(userTypeContext?.toString() !== Constants.UserType.Client ? [
            {
                field: 'sortCodeId',
                textAlign: 'center',
                headerAlign: 'center',
                headerName: t('SortCode'),
                editable: true,
                flex: 1,
                viewTier: 'standard',
                renderCell: (params) => {
                    const sortCode = sortCodesOptions.find((sc) => sc.value === params.value);
                    return <span>{sortCode ? sortCode.label : params.value || '-'}</span>;
                },
            },
            {
                field: 'frequency',
                textAlign: 'center',
                headerAlign: 'center',
                headerName: t('ExpenseFrequency'),
                editable: true,
                flex: 1,
                viewTier: 'standard',
                renderCell: (params) => {
                    if (params.value == null || params.value === '') return <span>-</span>;
                    const opt = Constants.ExpenseFrequencyOptions.find((o) => o.value === params.value);
                    if (opt) return <span>{t(`ExpenseFrequency_${opt.label}`)}</span>;
                    return <span>{t('ExpenseFrequency_EveryNMonths', { count: params.value })}</span>;
                },
            },
            {
                field: 'autoProcessed',
                textAlign: 'center',
                headerAlign: 'center',
                headerName: t('AutoProcessed'),
                editable: true,
                flex: 1,
                type: 'boolean',
                viewTier: 'standard',
                renderCell: (params) => (
                    <span>{params.value ? t('Yes') : t('No')}</span>
                ),
            }
        ] : []),
        // {
        //     field: 'document',
        //     textAlign: 'center',
        //     headerAlign: 'center',
        //     headerName: t('Document'),
        //     flex: 1,
        //     type: 'number',
        //     sortable: true,
        //     filterable: true,
        //     cellClassName: 'document-cell',
        //     valueGetter: (value, row) => {

        //         // valueGetter receives (value, row, column, apiRef) as separate parameters
        //         if (!row) {
        //             return 0;
        //         }
        //         return getDocumentStatus(row);
        //     },
        //     sortComparator: (v1, v2) => {
        //         // Sort: documents first (1), then no documents (0)
        //         // v1 and v2 are the values from valueGetter (0 or 1)
        //         const val1 = Number(v1) || 0;
        //         const val2 = Number(v2) || 0;
        //         // For ascending: val1 - val2 (0s first, then 1s)
        //         // For descending: val2 - val1 (1s first, then 0s)
        //         // Default behavior will handle both directions
        //         return val2 - val1;
        //     },
        //     valueFormatter: (params) => {
        //         // For filter display
        //         if (!params || params.value === undefined || params.value === null) {
        //             return '-';
        //         }
        //         return params.value === 1 ? t('HasDocument') || 'Has Document' : '-';
        //     },
        //     renderCell: (params) => {
        //         // Check if params and row exist
        //         if (!params || !params.row) {
        //             return <span>-</span>;
        //         }
        //         // Get documentUrls from the row - it might be a string (JSON) or array
        //         let documentUrls = [];
        //         if (params.row.documentUrls) {
        //             if (typeof params.row.documentUrls === 'string') {
        //                 try {
        //                     documentUrls = JSON.parse(params.row.documentUrls);
        //                 } catch (e) {
        //                     documentUrls = [];
        //                 }
        //             } else if (Array.isArray(params.row.documentUrls)) {
        //                 documentUrls = params.row.documentUrls;
        //             }
        //         }
                
        //         const hasDocument = documentUrls && documentUrls.length > 0;
        //         const documentUrl = hasDocument ? documentUrls[0] : null;

        //         if (!hasDocument) {
        //             return <span>-</span>;
        //         }

        //         return (
        //             <div
        //                 className="iframe-container"
        //                 onClick={() => openPdfInNewTab(documentUrl)}
        //                 style={{ 
        //                     cursor: 'pointer',
        //                     padding: '4px',
        //                     display: 'flex',
        //                     justifyContent: 'center',
        //                     alignItems: 'center'
        //                 }}
        //             >
        //                 <iframe
        //                     className="zoom-iframe"
        //                     src={`${documentUrl}#page=1`}
        //                     width="100px"
        //                     height="50px"
        //                     title={params.row.name || 'No Title'}
        //                     style={{
        //                         pointerEvents: 'none',
        //                         border: 'none',
        //                     }}
        //                 />
        //             </div>
        //         );
        //     },
        // },
        {
            field: 'actions',
            textAlign: 'center',
            headerAlign: 'center',
            type: 'actions',
            headerName: t('Actions'),
            flex: 0,
            width: 160,
            minWidth: 160,
            maxWidth: 180,
            viewTier: 'priority',
            getActions: params => {
                const { id } = params;

                // helper to avoid repeating the disabled + props
                const action = (icon, label, onClick) => (
                    <GridActionsCellItem
                        icon={icon}
                        label={label}
                        onClick={onClick}
                    />
                );

                const reservedSet = new Set((reservedAccountCardIds || []).map(String));
                const canMakeEditable = !params.row?.isEditable && !reservedSet.has(String(id));
                // Delete must not depend on isEditable: non-editable rows still need delete after "Make editable" was added.
                // Hide only for reserved system cards and unsaved new rows (no server id to delete yet).
                const canDelete =
                    !reservedSet.has(String(id)) && !params.row?.isNew;

                return [
                    action(<img src={editIcon} alt="Edit" />, 'Edit', () => handleEdit(id, params)),
                    ...(canDelete
                        ? [action(<img src={deleteIcon} alt="Del" />, 'Delete', handleDeleteClick(id))]
                        : []),
                    ...(canMakeEditable
                        ? [action(<LockOpen fontSize="small" />, t('MakeEditable') || 'Make editable', handleSetEditable(id))]
                        : []),
                    action(<img src={ledger} alt="Nav" />, 'Navigate', handleNavigateToDashboard(id)),
                ];
            },

        },
    ];

    const visibleColumns = useMemo(() => {
        const included = VIEW_INCLUDES_TIER[tableView] || VIEW_INCLUDES_TIER.standard;
        return columns
            .filter((col) => included.includes(col.viewTier))
            .map(({ viewTier, ...col }) => col);
    }, [columns, tableView]);

    const columnsWithWidths = useMemo(() => {
        const widthsForView = columnWidths[tableView] || {};
        return visibleColumns.map((col) => {
            const w = widthsForView[col.field];
            if (w != null && w > 0) {
                return { ...col, width: w, flex: undefined };
            }
            return col;
        });
    }, [visibleColumns, columnWidths, tableView]);

    const handleColumnWidthChange = (params) => {
        const field = params?.colDef?.field ?? params?.field;
        const width = params?.width;
        if (!field || width == null || width < 40) return;
        setColumnWidths((prev) => {
            const next = {
                ...prev,
                [tableView]: { ...(prev[tableView] || {}), [field]: width },
            };
            try {
                localStorage.setItem(STORAGE_KEY_ACCOUNT_CARDS_COLUMN_WIDTHS, JSON.stringify(next));
            } catch (_) {}
            return next;
        });
    };

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // handleBack();
            goBack()
        }
    };

    const openPdfInNewTab = (pdfUrl) => {
        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };

    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };

    const fileInputRef = useRef(null);
    const buttonData = [
        {
            label: 'Downloads',
            isDropdown: true,
            iconColor: 'green',
            style: { width: '160px', minWidth: '160px', maxWidth: '180px' },
            dropdownItems: [
                {
                    label: 'DownloadTemplate',
                    icon: () => <DownloadIcon fontSize="small" />,
                    onClick: () => handleDownloadTemplate(AccountCardFile, 'Xtram_accountCards_Template.xlsx'),
                },
                {
                    label: 'ExportAccountCardsToExcel',
                    icon: () => <DownloadIcon fontSize="small" />,
                    onClick: handleExportAccountCards,
                },
            ],
        },
        {
            label: 'Actions',
            isDropdown: true,
            iconColor: 'green',
            style: { width: '160px', minWidth: '160px', maxWidth: '180px' },
            dropdownItems: [
                {
                    label: 'MergeSelected',
                    icon: () => <MergeIcon fontSize="small" />,
                    onClick: handleOpenMergeSelected,
                    disabled: selectedRows.length < 2,
                },
                {
                    label: 'Edit',
                    icon: () => <EditIcon fontSize="small" />,
                    onClick: handleOpenEditSelected,
                    disabled: selectedRows.length === 0,
                },
                {
                    label: 'MakeSelectedEditable',
                    icon: () => <LockOpen fontSize="small" />,
                    onClick: handleMakeSelectedEditable,
                    disabled: selectedRows.length === 0,
                    loading: true,
                },
                {
                    label: 'MakeAllEditable',
                    icon: () => <LockOpen fontSize="small" />,
                    onClick: handleMakeAllEditable,
                    loading: true,
                },
                {
                    label: 'AddAccountCard',
                    icon: () => <AddCircleIcon fontSize="small" />,
                    onClick: () => setAddNewAccount(true),
                },
                {
                    label: 'BatchMergeAccountCards',
                    icon: () => <AutoAwesomeMotionIcon fontSize="small" />,
                    onClick: () => setBatchMergeModalVisible(true),
                },
                {
                    label: 'Import account cards from file',
                    icon: () => <DriveFolderUploadIcon fontSize="small" />,
                    onClick: () => handleFileButtonClick(fileInputRef, uploadFileToAccountCard),
                },
                {
                    label: t('PalCodePrefixes') || 'PalCode prefixes',
                    icon: () => <Settings fontSize="small" />,
                    onClick: () => setPrefixDialogOpen(true),
                },
                {
                    label: 'ReorderByPrefix',
                    icon: () => <AutoAwesomeMotionIcon fontSize="small" />,
                    onClick: () => setReorderDialogOpen(true),
                },
                {
                    label: 'DeleteSelectedAccountCards',
                    icon: () => <DeleteIcon fontSize="small" />,
                    onClick: handleOpenBulkDeleteSelected,
                    danger: true,
                    disabled: selectedRows.length === 0,
                },
                {
                    label: 'DeleteZeroTransactionCards',
                    icon: () => <DeleteIcon fontSize="small" />,
                    onClick: handleOpenZeroTransactionDelete,
                    danger: true,
                }
            ],
        },
        {
            label: 'SystemAccountSettings',
            icon: () => <Settings fontSize="small" />,
            onClick: () => setSystemSettingsDialogOpen(true),
            style: { width: '180px', minWidth: '140px', maxWidth: '180px' },
        },
    ];
    return (
        <>
            <MergeAccountCards
                isVisible={isMergeModalVisible}
                onClose={() => setMergeModalVisible(false)}
                accountCardsData={accountCardsData}
                setAccountCardsData={setAccountCardsData}
                handleAccountMerge={handleMerge}
            />

            <BatchMergeAccountCards
                isVisible={isBatchMergeModalVisible}
                onClose={() => setBatchMergeModalVisible(false)}
                accountCardsData={accountCardsData}
                handleBatchMerge={handleBatchMerge}
                caseId={client?.caseId}
                token={token}
            />

            <MergeSelectedCardsDialog
                open={mergeSelectedModalVisible}
                onClose={() => !mergeSelectedProcessing && setMergeSelectedModalVisible(false)}
                cards={selectedCardsForMerge}
                onConfirm={handleMergeSelectedConfirm}
                isProcessing={mergeSelectedProcessing}
            />

            <PreviewUploadDialog
                isVisible={isPreviewDialogVisible}
                onClose={() => {
                    setIsPreviewDialogVisible(false);
                    setUploadedFile(null);
                }}
                previewData={previewData}
                onConfirm={handleConfirmImport}
                onShowConflicts={handleShowConflicts}
                loading={loading}
            />

            <ConflictResolutionDialog
                isVisible={isConflictDialogVisible}
                onClose={() => setIsConflictDialogVisible(false)}
                conflicts={uploadConflicts}
                caseId={client?.caseId}
                onResolved={handleConflictResolved}
            />

            <PalCodePrefixesDialog
                open={prefixDialogOpen}
                onClose={() => setPrefixDialogOpen(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSave={handleSavePrefixes}
            />

            <SystemAccountSettingsDialog
                open={systemSettingsDialogOpen}
                onClose={() => setSystemSettingsDialogOpen(false)}
                caseId={client?.caseId}
                token={token}
                accountCardsData={accountCardsData}
                sortCodesOptions={sortCodesOptions}
                onSaved={() => fetchEnums(token, client)}
            />

            <ReorderByPrefixDialog
                open={reorderDialogOpen}
                onClose={() => setReorderDialogOpen(false)}
                caseId={client?.caseId}
                token={token}
                palCodesOptions={palCodesOptions || []}
                onSuccess={() => fetchEnums(token, client)}
            />

            <Dialog
                open={makeEditableConfirmOpen}
                onClose={handleMakeEditableConfirmClose}
                maxWidth="xs"
                fullWidth
                dir={dir}
                aria-labelledby="make-editable-dialog-title"
                aria-describedby="make-editable-dialog-description"
            >
                <DialogTitle id="make-editable-dialog-title">
                    {makeEditableConfirmPayload?.type === 'all'
                        ? (t('MakeAllEditableConfirmTitle') || 'Make all cards editable?')
                        : (t('MakeSelectedEditableConfirmTitle') || 'Make selected cards editable?')}
                </DialogTitle>
                <DialogContent>
                    <Box id="make-editable-dialog-description" sx={{ pt: 0.5 }}>
                        {makeEditableConfirmPayload?.type === 'all' ? (
                            <p style={{ margin: 0 }}>
                                {t('MakeAllEditableConfirmDescription', {
                                    count: makeEditableConfirmPayload?.count ?? 0,
                                    defaultValue: `All ${makeEditableConfirmPayload?.count ?? 0} account cards in this case will be marked as editable. You will then be able to edit their details (name, PAL code, etc.) directly in the table.`,
                                })}
                            </p>
                        ) : (
                            <p style={{ margin: 0 }}>
                                {t('MakeSelectedEditableConfirmDescription', {
                                    count: makeEditableConfirmPayload?.count ?? 0,
                                    defaultValue: `${makeEditableConfirmPayload?.count ?? 0} selected card(s) will be marked as editable. You will then be able to edit their details directly in the table.`,
                                })}
                            </p>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleMakeEditableConfirmClose}>{t('cancelButton') || 'Cancel'}</Button>
                    <Button variant="contained" onClick={handleMakeEditableConfirm} color="primary">
                        {t('MakeEditable') || 'Make editable'}
                    </Button>
                </DialogActions>
            </Dialog>

            <CustomDeleteConfirmationModal
                isVisible={deleteModalVisible}
                onClose={() => setDeleteModalVisible(false)}
                onDelete={handleConfirmDelete}
            />
            <CustomDeleteConfirmationModal
                isVisible={bulkDeleteModalVisible}
                onClose={() => {
                    if (!bulkDeleteProcessing) {
                        setBulkDeleteModalVisible(false);
                        setBulkDeleteCardIds([]);
                    }
                }}
                onDelete={handleConfirmBulkDelete}
                confirmMessage="confirmDeleteMultipleAccountCards"
                confirmValues={{ count: bulkDeleteCardIds.length }}
                isProcessing={bulkDeleteProcessing}
            />

            <DeleteZeroTransactionCardsDialog
                open={zeroTxDeleteModalOpen}
                onClose={() => {
                    if (!bulkDeleteProcessing && !zeroTxLoading) {
                        setZeroTxDeleteModalOpen(false);
                        setZeroTxCards([]);
                    }
                }}
                cards={zeroTxCards}
                loading={zeroTxLoading}
                isProcessing={bulkDeleteProcessing}
                onConfirmDelete={handleConfirmZeroTransactionDelete}
            />

            <>
                <Box dir={dir} sx={{ width: '100%' }}>
                    <NavigationButton
                        t={t}
                        direction={direction}
                        selectedRows={selectedRows}
                        fileInputRef={fileInputRef}
                        templateFile={AccountCardFile}
                        templateFileName="Xtram_accountCards_Template.xlsx"
                        data={buttonData}
                    />

                    <div className={`${styles.filterRow} document-filter-row`} dir={direction}>
                        <TextField
                            size="small"
                            dir={direction}
                            placeholder={t('searchAccountCards')}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="document-search-bar"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon className="document-search-icon" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <div className={styles.filtersSelect}>
                            <AutocompleteSelectFilter
                                options={palCodeOptionsWithPrefix || []}
                                selectedValues={selectedPalCodeOption}
                                onChange={(event, newValue) => {
                                    setSelectedPalCode(newValue);
                                }}
                                label={t('SelectPalCode')}
                                placeholder={t('SearchPalCodeOrNumber') || t('SelectPalCode')}
                                isMultiple={false}
                                direction={direction}
                                portalMenu
                                searchable
                            />
                        </div>
                        <div className={styles.tableViewGroup}>
                            <FormControl size="small" className={styles.tableViewControl}>
                                <InputLabel id="account-cards-view-label">{t('TableView')}</InputLabel>
                                <Select
                                    labelId="account-cards-view-label"
                                    value={tableView}
                                    label={t('TableView')}
                                    dir={direction}
                                    MenuProps={TABLE_VIEW_MENU_PROPS}
                                    onChange={(e) => setTableView(e.target.value)}
                                    sx={{
                                        height: 'var(--xtram-control-height, 40px)',
                                        minHeight: 'var(--xtram-control-height, 40px)',
                                        '& .MuiSelect-select': {
                                            textAlign: direction === 'rtl' ? 'left' : 'right',
                                            py: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                    }}
                                >
                                    <MenuItem dir={direction} value="compact">{t('TableViewCompact')}</MenuItem>
                                    <MenuItem dir={direction} value="standard">{t('TableViewStandard')}</MenuItem>
                                    <MenuItem dir={direction} value="full">{t('TableViewFull')}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        {/* Bulk Edit Dialog */}
                        <BulkEditDialog
                            open={openEditSelected}
                            onClose={handleCloseEditSelected}
                            direction={direction}
                            palCodesOptions={palCodesOptions}
                            sortCodesOptions={sortCodesOptions}
                            selectedPalCodeForSelectAll={selectedPalCodeForSelectAll}
                            setSelectedPalCodeForSelectAll={setSelectedPalCodeForSelectAll}
                            selectedSortCodeForSelectAll={selectedSortCodeForSelectAll}
                            setSelectedSortCodeForSelectAll={setSelectedSortCodeForSelectAll}
                            selectedAutoProcessedForSelectAll={selectedAutoProcessedForSelectAll}
                            setSelectedAutoProcessedForSelectAll={setSelectedAutoProcessedForSelectAll}
                            selectedSourceDeductionForSelectAll={selectedSourceDeductionForSelectAll}
                            setSelectedSourceDeductionForSelectAll={setSelectedSourceDeductionForSelectAll}
                            selectedDeductionTypeForSelectAll={selectedDeductionTypeForSelectAll}
                            setSelectedDeductionTypeForSelectAll={setSelectedDeductionTypeForSelectAll}
                            selectedTaxAssessorForSelectAll={selectedTaxAssessorForSelectAll}
                            setSelectedTaxAssessorForSelectAll={setSelectedTaxAssessorForSelectAll}
                            selectedDeductionRateForSelectAll={selectedDeductionRateForSelectAll}
                            setSelectedDeductionRateForSelectAll={setSelectedDeductionRateForSelectAll}
                            selectedDeductionValidityForSelectAll={selectedDeductionValidityForSelectAll}
                            setSelectedDeductionValidityForSelectAll={setSelectedDeductionValidityForSelectAll}
                            selectedPaymentTermsTypeForSelectAll={selectedPaymentTermsTypeForSelectAll}
                            setSelectedPaymentTermsTypeForSelectAll={setSelectedPaymentTermsTypeForSelectAll}
                            selectedPaymentTermsDaysForSelectAll={selectedPaymentTermsDaysForSelectAll}
                            setSelectedPaymentTermsDaysForSelectAll={setSelectedPaymentTermsDaysForSelectAll}
                            selectedIncludeInCashFlowForSelectAll={selectedIncludeInCashFlowForSelectAll}
                            setSelectedIncludeInCashFlowForSelectAll={setSelectedIncludeInCashFlowForSelectAll}
                            selectedCashFlowCodeForSelectAll={selectedCashFlowCodeForSelectAll}
                            setSelectedCashFlowCodeForSelectAll={setSelectedCashFlowCodeForSelectAll}
                            selectedCashFlowAverageAmountForSelectAll={selectedCashFlowAverageAmountForSelectAll}
                            setSelectedCashFlowAverageAmountForSelectAll={setSelectedCashFlowAverageAmountForSelectAll}
                            onSave={handleEditInBulk}
                            userTypeContext={userTypeContext}
                        />


                    </div>

                    <div className={`${direction}`} style={{ width: '100%', height: '60vh', marginTop: '20px' }}>


                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getLocale()}>
                            <StyledDataGrid
                                key={tableView}
                                apiRef={apiRef}
                                rows={rows}
                                columns={columnsWithWidths}
                                onColumnWidthChange={handleColumnWidthChange}
                                checkboxSelection={true}
                                disableSelectionOnClick
                                columnHeaderHeight={42}
                                getRowHeight={() => 'auto'}
                                getEstimatedRowHeight={() => 52}
                                rowSelectionModel={selectedRows}
                                onRowSelectionModelChange={handleSelectionModelChange}
                                getRowId={(row) => row.cardId} // Use row.cardId as the row ID
                                components={{
                                    Toolbar: EditToolbar,
                                }}
                                componentsProps={{
                                    toolbar: { setRows, setRowModesModel },
                                }}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                isRowSelectable={isRowSelectable} // Rows not selectable if isEditable is false
                                // processRowUpdate={processRowUpdate}
                                experimentalFeatures={{ newEditingApi: true }}
                                editMode="row"
                                rowModesModel={rowModesModel}
                                onRowModesModelChange={setRowModesModel}
                                onRowDoubleClick={handleRowDoubleClick}
                                isCellEditable={(params) => isRowSelectable(params)} // Cells not editable if row is not selectable

                            />
                        </LocalizationProvider>
                    </div>

                {/* <HamburgerMenu client={client} /> */}
                {isModalOpen && (
                    <AddAccountCardModal
                        /* === data sources === */
                        accountCardOptions={accountCardsData}
                        editedItem={selectedRow}
                        palCodes={palCodesOptions}
                        open={isModalOpen}
                        onClose={handleCloseEditAddModal}
                        isEdit={!isNew}
                        isAdd={isNew}
                        isRange={false}
                        isClosedReportingMonth={false}
                        propPalCode={null}
                        setPalCode={() => { }}
                        direction={direction}
                        client={client}
                        token={token}
                        setLoading={setLocalLoading}
                        handleChangeAfterAdd={() => { }}
                        fetchEnums={client && token ? () => fetchEnums(token, client) : fetchEnumsFromAccountCards}
                    />
                )}

                <ToastContainer />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}

                {/* Document Preview Modal */}
                <Dialog
                    open={bigIframeModalOpen}
                    onClose={handleCloseIframeModal}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{
                        style: {
                            width: '90%',
                            height: '90%',
                            maxWidth: '90%',
                            maxHeight: '90%',
                        },
                    }}
                >
                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <span>{t('Document')}</span>
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={handleCloseIframeModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ padding: 0, height: '100%' }}>
                        {openedIframeUrl && (
                            <iframe
                                src={openedIframeUrl}
                                width="100%"
                                height="100%"
                                style={{
                                    border: 'none',
                                    minHeight: '80vh',
                                }}
                                title="Document Preview"
                            />
                        )}
                    </DialogContent>
                </Dialog>
                </Box>
            </>
        </>
    );
});

export default AccountCardsTable;
